/*
 * Created on Thu Oct 12 2023 10:25:28 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { BadgeCheck } from 'lucide-react';
import { useEffect } from 'react';
import { Media } from '../../components/MediaSkeleton';
// import { logger } from '../../Error-handlers/logger';

const getConfirmedCourses = () => {
  try {
    const storedCourses = JSON.parse(localStorage.getItem('pList')) || [];
    return Array.isArray(storedCourses) ? storedCourses : [];
  } catch {
    return [];
  }
};

const PaymentConfirmation = () => {
  const courses = getConfirmedCourses();

  useEffect(() => {
    if (!courses.length) return;
    try {
      const pending = courses.map((course) => ({
        id: course.primaryId || course.courseCode,
        product: course,
        orderDate: new Date().toISOString(),
        type: 'pending',
        status: 'PROCESSING',
        pending: true,
      }));
      localStorage.setItem('pendingEnrollments', JSON.stringify(pending));
    } catch {
      // Storage is best-effort; API reconciliation remains authoritative.
    }
  }, [courses]);

  return (
    <main
      id="payment-confirmation"
      className="mx-auto max-w-6xl px-4 pt-12 text-center"
    >
      <BadgeCheck size={76} className="mx-auto mb-4 text-green-500" />
      <h1 className="mb-3 text-4xl font-bold text-gray-900">
        Payment Successful
      </h1>
      <p className="mb-3 text-xl font-semibold text-gray-700">
        We have received your Payment
      </p>
      <p className="mb-6 text-xl font-semibold text-gray-700">
        You are now enrolled in the following course:
      </p>
      <div className="flex justify-center">
        {courses.map((course) => (
          <Media
            key={course.courseCode || course.primaryId}
            id={course.courseCode}
            content={course}
            paid={course.price}
            loggedIn={true}
            src={"./images/img/course_6.jpg"}
          />
        ))}
      </div>
      <p className="mt-6 text-xl font-semibold text-gray-700">
        <a href="/products" className="font-bold text-blue-600 underline">Click here</a> to check out our complete course catalog
      </p>
    </main>
  );
};

export default PaymentConfirmation;
